module.exports = __webpack_public_path__ + "media/platformer-gameplay.534fbefb.mp4";